import { RepoFactory } from '@/baseRepository/Factory';
const supplierRepository = () => RepoFactory.get('supplier');

export const businessInformationActions = {
  getSupplierInformation(context, params) {
    return new Promise((resolve, reject) => {
      supplierRepository()
        .getSupplierByUser(context.getters.merchantBaseUrl, {
          ...params,
        })
        .then((res) => {
          context.commit('setUserBusinessInformation', res.data);
          context.commit('setCurrentMerchant', res.data.merchantId);
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
